module.exports = __webpack_public_path__ + "static/media/Limitations.57c4e126.svg";